export default __webpack_public_path__ + "static/media/limit_25.4d965062.svg";